export const environment = {
  production: true,
  //apiUrl: 'http://gcaseqa-001-site13.atempurl.com'
  apiUrl: 'https://webapitecnikal.sfsolutions.mx'
  //apiUrl: 'http://localhost:14588/'
};
